import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'cmp-main-v1',
  template: `<header id="cmp-header">
  <cmp-nav-top [version]="version"
               [templateMenuDesktop]="templateMenuDesktop"
               [templateMenuMobile]="templateMenuMobile"
               (powerClick)="powerClick.emit(null)"
               [asideTemplate]="asideTemplate">
    <ng-content select="[sidebar]"></ng-content>
  </cmp-nav-top>
</header>

<div class="main-wrap">
  <input id="slide-sidebar" type="checkbox" role="button"/>
  <label for="slide-sidebar" class="fa fa-bars"></label>
  <div id="cmp-sidebar">

    <div class="sidebar">
      <cmp-sidebar-menu
        (onChangeOrg)="onChangeOrg.emit($event)"
        [organization]="organization"
        [data]="menu" (onNavigate)="onNavigate.emit($event)">
      </cmp-sidebar-menu>
    </div>
  </div>
  <div class="main-content p-4">
    <ng-content select="[body]"></ng-content>
  </div>
</div>
`,
  styles: [`.sidebar{width:260px;position:fixed;top:54px;left:0;height:calc(100% - 54px)}.main-content{background-color:#fff;position:absolute;top:54px;left:260px;right:0;border-left:1px solid #ccc;min-height:100%;font-size:80%;transition:left .5s}@media print{#cmp-header,#cmp-sidebar{display:none}.main-content{background-color:#fff;position:absolute;width:100%;left:0;top:0;zoom:.5;min-height:100%;border-left:none;font-size:80%;-webkit-print-color-adjust:exact}}label{z-index:1040;position:fixed;top:10px;left:10px;background-color:#f8f9fa;padding:8px 9px;border-radius:17px;transition:left .5s}label:hover{background-color:#e2e6ea}input[type=checkbox]{display:none}input:checked~.main-content{left:50px}input:checked~label{left:10px}`]
})
export class MainV1Component implements OnInit {

  @Input() menu = [];
  @Input() asideTemplate;
  @Input() templateMenuDesktop;
  @Input() templateMenuMobile;
  @Input() version: any;
  @Input() organization: any;
  @Output() onNavigate = new EventEmitter();
  @Output() onChangeOrg = new EventEmitter();
  @Output() inputAsideEmit = new EventEmitter();
  @Output() powerClick = new EventEmitter();
  @Output() isAsideOpen = new EventEmitter();

  constructor() {
  }

  ngOnInit() {
  }
}
